export const supportedCurrencies = [
  'AUD',
  'CNY',
  'HKD',
  'MOP',
  'MYR',
  'NZD',
  'PHP',
  'SGD',
  'THB',
  'TWD',
  'IDR',
  'JPY',
  'KRW',
  'VND',
  'CHF',
  'DKK',
  'EUR',
  'GBP',
  'NOK',
  'SEK',
  'USD',
  'CAD',
];

// shared props for currency select dropdowns to make them scrollable
export const currencySelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: 500,
    },
  },
};
